import { render, staticRenderFns } from "./personalDataPoliticsModal.vue?vue&type=template&id=1d6300b9&"
import script from "./personalDataPoliticsModal.vue?vue&type=script&lang=js&"
export * from "./personalDataPoliticsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports